import styled from '@emotion/styled'
import React, {forwardRef} from 'react'
import {PALETTE} from '~/styles/paletteV3'

const Container = styled('div')({
  alignItems: 'center',
  display: 'flex',
  flex: 1,
  minWidth: 0
})

const IconContainer = styled('div')({
  marginRight: 16
})

const MenuToggleLabelContainer = styled('div')({
  overflow: 'hidden'
})

const MenuToggleLabel = styled('div')({
  flex: 1,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  fontSize: 20,
  fontWeight: 600,
  color: PALETTE.SLATE_900
})

const MenuToggleTitle = styled('div')({
  fontSize: 14,
  lineHeight: '16px',
  fontWeight: 400,
  color: PALETTE.SLATE_900
})






const DropdownToggleInner = forwardRef((props, ref) => {
  const {icon, label, title} = props
  return (
    React.createElement(Container, { ref: ref,}
      , icon && React.createElement(IconContainer, null, icon)
      , React.createElement(MenuToggleLabelContainer, null
        , title && React.createElement(MenuToggleTitle, null, title)
        , React.createElement(MenuToggleLabel, null, label)
      )
    )
  )
})

export default DropdownToggleInner
